import { Context } from '@nuxt/types'

declare global {
  interface Window {
    $workbox: Promise<any>
  }
}

// Key used for localStorage to simulate PWA update
const PWA_UPDATE_PENDING_KEY = 'pwaUpdatePending'

// PWA update detection
async function checkForPWAUpdate(_: Context) {
  const workbox = await window.$workbox
  if (!workbox) {
    console.debug("Workbox couldn't be loaded.") // eslint-disable-line
    return
  }
  workbox.addEventListener('installed', (event: any) => {
    if (event.isUpdate === true) {
      console.debug('There is an update for the PWA') // eslint-disable-line
      localStorage.setItem(PWA_UPDATE_PENDING_KEY, 'true')
    } else {
      console.debug('The PWA is on the latest version.') // eslint-disable-line
      localStorage.setItem(PWA_UPDATE_PENDING_KEY, 'false')
    }
  })
}

// Navigation guard
function setupNavigationGuard(app) {
  app.router.beforeEach((to, from, next) => {
    const isUpdatePending =
      localStorage.getItem(PWA_UPDATE_PENDING_KEY) === 'true'
    if (isUpdatePending) {
      console.log('pwa.navguard', isUpdatePending)
      localStorage.setItem(PWA_UPDATE_PENDING_KEY, 'false')
      window.location.href = to.fullPath
    } else {
      next()
    }
  })
}

export default async function (ctx) {
  await checkForPWAUpdate(ctx)
  setupNavigationGuard(ctx.app)
}
